/**
 * Appointment time for display. `appointments.start_time` is a TIME column
 * ("10:00:00") which `new Date()` cannot parse — the scribe appointment page
 * showed "Invalid Date" for it (commons GH-184, 2026-09-18) while the list
 * page had its own HH:MM handling. One formatter for both.
 */
export function formatApptTime(value) {
  if (!value) return '--';
  try {
    const timeMatch = String(value).match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
    if (timeMatch) {
      const h = Number(timeMatch[1]);
      const m = Number(timeMatch[2]);
      const period = h >= 12 ? 'PM' : 'AM';
      const hour12 = h % 12 || 12;
      return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) return '--';
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  } catch { return '--'; }
}

/** First time-looking field on an appointment row (TIME string vs full timestamp shapes). */
export function pickApptTime(appt) {
  return appt?.start_time
    || appt?.appointment_time
    || appt?.appointment_date
    || appt?.starts_at
    || '';
}
